(function ($, Drupal) {
    jQuery(document).ready(function ($) {

        // base slider
        var SlideWrap = $('.slick');
        if (SlideWrap.length) {
            SlideWrap.slick({ autoplay: true, fade: true, cssEase: 'linear' });
        }

        // default slider
        var SlideWrapSpotLight = $('.slick-default');
        if (SlideWrapSpotLight.length) {
            SlideWrapSpotLight.slick();
        }

        // wrap company name in footer
        $(".block-copyright-footer .block__content").html(function (_, html) {
            return $(this).html().replace(/(Mu Alpha Theta)/g, '<span class="company">$1</span>');
        });

        // pdf file link
        $(".file--application-pdf a").attr('target', '_blank');

        // custom menu trigger
        $(".block-custom-links-block .tabs__trigger").click(function(){
            // $(".block-custom-links-block").find('.tabs__tab').toggleClass('show');
            $(".block-custom-links-block").find('.tabs').toggleClass('is-expanded');
            $(this).toggleClass('is-expanded');
        });

        // Initially hide the .migration-graduated li if radio value is 0
        toggleGraduatedMigration($('.migration-switch-btn input:checked').val());

        // Event listener for radio buttons change
        $('.migration-switch-btn input[type="radio"]').change(function () {
            var value = $(this).val();
            toggleGraduatedMigration(value);
        });

        // Function to show/hide .migration-graduated based on radio value
        function toggleGraduatedMigration(value) {
            if (value === '1') {
                $('.migration-graduated').show();
            } else {
                $('.migration-graduated').hide();
            }
        }

        var currentPath = window.location.pathname + window.location.search;
        $('.manage-chapter-menu .tabs__link').each(function () {
            var linkHref = $(this).attr('href');
            if (currentPath === linkHref) {
                $(this).addClass('is-active');
            }
        });

        // chapterid
        $(".node--type-manage-chapters .field--name-field-old-chapter-id").clone().insertAfter(".node__meta");

    });
})(jQuery, Drupal);
